import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import Empty from 'antd/lib/empty';
import Skeleton from 'antd/lib/skeleton';
import { getPublicAnnouncementByIdentifier } from '../api/announcements';
import { mapApiAnnouncementToCard } from '../api/announcements.mappers';
import FooterBar from '../components/helpdesk/FooterBar';
import HeaderBar from '../components/helpdesk/HeaderBar';
import '../styles/helpdesk.scss';

function PublicAnnouncementPage() {
  const { identifier } = useParams();
  const location = useLocation();
  const stateAnnouncement = location.state?.announcement || null;
  const [announcement, setAnnouncement] = useState(stateAnnouncement);
  const [loading, setLoading] = useState(!stateAnnouncement);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    async function loadAnnouncement() {
      setLoading(true);
      setNotFound(false);
      try {
        const response = await getPublicAnnouncementByIdentifier(identifier);
        setAnnouncement(response);
      } catch {
        if (!stateAnnouncement) setNotFound(true);
      } finally {
        setLoading(false);
      }
    }

    loadAnnouncement();
  }, [identifier, stateAnnouncement]);

  const mapped = useMemo(() => mapApiAnnouncementToCard(announcement || {}), [announcement]);
  const formattedDate = useMemo(() => {
    if (!mapped.date) return '-';
    const parsed = new Date(mapped.date);
    if (Number.isNaN(parsed.getTime())) return '-';
    return parsed.toLocaleDateString();
  }, [mapped.date]);

  return (
    <div className="helpdesk-page">
      <HeaderBar />
      <main className="helpdesk-main">
        <div className="helpdesk-main__inner">
          <section className="public-article">
            {loading ? (
              <Skeleton active paragraph={{ rows: 6 }} />
            ) : notFound ? (
              <Empty description="Announcement not found" />
            ) : (
              <>
                <Link to="/announcements" className="create-article__back">
                  {'<-'} Back to Announcements
                </Link>

                <header className="public-article__header">
                  <p className="public-article__kicker">Announcement</p>
                  <h1>{mapped.title}</h1>
                  <p className="public-article__excerpt">{mapped.description}</p>
                  <div className="public-article__meta">
                    <span className="public-article__author">{mapped.priority}</span>
                    <span>{formattedDate}</span>
                  </div>
                </header>

                <article className="public-article__content">
                  <p>{announcement?.content || mapped.description}</p>
                </article>
              </>
            )}
          </section>
        </div>
      </main>
      <FooterBar />
    </div>
  );
}

export default PublicAnnouncementPage;
